import React from 'react'
import cl from './CollectingStatistics.module.css'
import { Box, Button, Flex, Grid, Heading, Input, Select, Table, Tbody, Td, Th, Tr } from '@chakra-ui/react'

function CollectingStatisticsMain() {
    return (
        <Grid gap='var(--default-gap)'>
            <Grid className={cl.container} marginRight='auto'>
                <Heading size='md'>Статистика</Heading>
                <Flex gap='var(--default-gap)'>
                    <Input
                        size='sm'
                        maxW='150px'
                        type='date'
                        placeholder='Выбор даты'
                    />
                    <Select
                        size='sm'
                        maxW='200px'
                        placeholder='Выбор отдела'
                    >
                        <option>Отдел 1</option>
                        <option>Отдел 2</option>
                    </Select>
                    <Select
                        size='sm'
                        maxW='200px'
                        placeholder='Выбор предмета'
                    >
                        <option>Русский</option>
                        <option>Математика</option>
                    </Select>
                    <Button
                        size='sm'
                        minW='100px'
                    >
                        Обновить
                    </Button>
                </Flex>
            </Grid>
            <Box className={cl.tableWrapper}>
                <Table className={cl.table}>
                    <Tbody>
                        <Tr>
                            <Th>Всего учеников:</Th>
                            <Td></Td>
                            <Td></Td>
                            <Td></Td>
                        </Tr>
                        <Tr>
                            <Th>Всего предметов:</Th>
                            <Td></Td>
                            <Td></Td>
                            <Td></Td>
                        </Tr>
                        <Tr>
                            <Th>Отписано (по ученикам):</Th>
                            <Td></Td>
                            <Td></Td>
                            <Td></Td>
                        </Tr>
                        <Tr>
                            <Th>Собрано баллов (по предметам):</Th>
                            <Td></Td>
                            <Td></Td>
                            <Td></Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>
        </Grid>
    )
}

export default CollectingStatisticsMain
